import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { StatusSpecs, statusSpecs } from '@/data/transactionStatuses';
import { useTranslator } from '@/hooks/useTranslator';
import { SimplifiedTransactionStatus } from '@/types/transaction';

interface Props {
  readonly status: SimplifiedTransactionStatus;
}

export const DetailsStatus: React.FC<Props> = (props: Props): React.ReactElement => {
  const { status } = props;

  const tr = useTranslator();
  const specs = React.useMemo((): StatusSpecs => statusSpecs(status), [status]);

  return (
    <Box sx={styles.container} bgcolor={specs.backgroundColor}>
      <Typography variant="body1" color={specs.color}>
        {tr(specs.label)}
      </Typography>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    px: 1,
    flexShrink: 0,
    borderRadius: 2,
  },
};
